import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import './alert.html';
import './alert.scss';

@injectable()
export default class WCCAlertVM {
    constructor(
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-alert': true
            }
        });
    }
}